import { create } from 'zustand';

export const useAuthStore = create((set) => ({
  user: null,
  authStatus: 'checking', // 'checking' | 'authenticated' | 'anonymous'
  _hasHydrated: true, // no persisted auth secrets; ready immediately

  setUser: (user) => set({ user, authStatus: user ? 'authenticated' : 'anonymous' }),
  setAuthStatus: (authStatus) => set({ authStatus }),

  logoutLocal: () => set({ user: null, authStatus: 'anonymous' }),

  updateUser: (userData) =>
    set((state) => ({
      user: state.user ? { ...state.user, ...userData } : null,
    })),

  clearMustChangePassword: () =>
    set((state) => ({
      user: state.user ? { ...state.user, mustChangePassword: false } : null,
    })),
}));
